module.exports = __webpack_public_path__ + "img/22.YamahaR15Black.3047e801.png";